import { FC, SVGProps } from 'react';

import LayersIcon from '@/assets/svg/ui-elements/layers.svg';
import RocketIcon from '@/assets/svg/ui-elements/rocket.svg';
import StarIcon from '@/assets/svg/ui-elements/star.svg';
import UsersGroupRoundedIcon from '@/assets/svg/ui-elements/users-group-rounded.svg';

type SvgIcon = FC<SVGProps<SVGSVGElement>>;

const tagIconMap: Record<string, SvgIcon> = {
  'Family Office': UsersGroupRoundedIcon,
  FamilyOffice: UsersGroupRoundedIcon,
  'Fund of Funds': LayersIcon,
  VC: RocketIcon,
  VIP: StarIcon,
};

const DefaultTagIcon = UsersGroupRoundedIcon;

export const getTagIcon = (tagName: string): SvgIcon => tagIconMap[tagName] ?? DefaultTagIcon;
